import { RoleCell } from './styled';

interface Props {
    value?: string;
}

const RoleColumn = ({ value }: Props) => (
    <RoleCell>{value}</RoleCell>
);

export default RoleColumn;
